import { useEffect, useState } from "react";
import { apiJson } from "../api/client";
import { clearReferral, readReferral } from "../lib/referrals";
import { useLocale } from "../contexts/LocaleContext";

export function ReferralAttribution() {
  const { t } = useLocale();
  const [name, setName] = useState("");
  useEffect(() => {
    const code = readReferral();
    if (!code) return;
    let active = true;
    apiJson<{ name: string }>(`/referrals/lookup/${code}`).then(data => {
      if (active) setName(data.name);
    }).catch(error => {
      if (String(error).includes("HTTP 404")) clearReferral();
    });
    return () => { active = false; };
  }, []);
  return name ? <p className="referral-attribution">{t("referral.recommendedBy", { name })}</p> : null;
}
